import { render, staticRenderFns } from "./AdminTotpSetupStep.vue?vue&type=template&id=d765ba82"
import script from "./AdminTotpSetupStep.vue?vue&type=script&lang=js"
export * from "./AdminTotpSetupStep.vue?vue&type=script&lang=js"
import style0 from "./AdminTotpSetupStep.vue?vue&type=style&index=0&id=d765ba82&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports